import Glide from '@glidejs/glide';
import SliderBulletNav from './SliderBulletNav';

/**
 * Hero Slider based on GlideJS
 * @see https://glidejs.com/docs/
 */
export default class ContentSlider {
  /**
   * constructor
   * Checks if selector [data-slider] exists fires init-function.
   * @param {object} options
   */
  constructor(options = {}) {
    this.config = {
      selector: '[data-slider]',
      ...options,
    };

    this.sliders = document.querySelectorAll(this.config.selector);

    if (!this.sliders.length) {
      return;
    }

    this.init();
  }

  /**
   * Initializes glidejs-slider.
   * Glidejs options are set in Contao backend with the [data-content-slider-config]-attribute.
   * Contao passes the value as an array of strings:
   * [autoplay, animationDuration, startAt, carousel]
   * and parsed to number in this method.
   *
   * @param {String} autoplay - Milliseconds number
   * @param {String} animationDuration - Milliseconds number
   * @param {String} startAt - Starting position number
   * @param {String} carousel - Number 1 or 0.
   */
  init() {
    this.sliders.forEach((slider) => {
      const paramSelector = slider.querySelector('[data-config]');
      const params = paramSelector?.dataset.config.split(',');
      const [autoplay, animationDuration, startAt, carousel] = params.map((v) => parseInt(v, 10));

      /**
       * @see https://glidejs.com/docs/options/
       */
      const glideConfig = {
        type: carousel === 1 ? 'carousel' : 'slider',
        autoplay,
        animationDuration,
        startAt,
        rewind: false,
      };

      this.slider = new Glide(slider, glideConfig);
      /**
       * The custom glidejs-module SliderPagination is passed in the mount-function.
       * @see module:SliderPagination
       */
      this.slider.mount({ SliderBulletNav });
    });
  }
}
